import { render, staticRenderFns } from "./TabsInput.vue?vue&type=template&id=46d76361"
import script from "./TabsInput.vue?vue&type=script&lang=js"
export * from "./TabsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports